define('modules/editor/views/property_boxes/label',['require','exports','module','./base','fontmanager','spectrum','ldsh!../../templates/property_boxes/label'],function(require, exports, module) {
  "use strict";
  var BasePropertyBox = require("./base"),
      FontManager = require("fontmanager"),
      SpectrumColorPicker = require("spectrum");
  //label properties for button
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/label"),
    helpers: function() {
      return {
        fonts: FontManager.getNames()
      };
    }
  });
});

